export default __webpack_public_path__ + "lib/crop-example.e9de0e49471f69deefc6b011e4a57fa1.jpg";